export interface IWorldParts {
  name: string,
  sourceUrl: string,
  title: string,
  active: boolean
}

export const JURISDICTIONS = 'jurisdictions';

export const worldParts: IWorldParts[] = [
  {
    name: 'americas',
    title: '',
    sourceUrl: '',
    active: false,
  }, {
    name: 'africa',
    title: '',
    sourceUrl: '',
    active: false,
  }, {
    name: 'europe',
    title: '',
    sourceUrl: '',
    active: false,
  }, {
    name: 'asia',
    title: '',
    sourceUrl: '',
    active: false,
  }, {
    name: 'oceania',
    title: '',
    sourceUrl: '',
    active: false,
  },

];
